import { render, staticRenderFns } from "./AddRoleP2.vue?vue&type=template&id=5c117136&"
import script from "./AddRoleP2.vue?vue&type=script&lang=js&"
export * from "./AddRoleP2.vue?vue&type=script&lang=js&"
import style0 from "./AddRoleP2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports